import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Import translations directly
const enTranslations = require("./locales/en.json");
const esTranslations = require("./locales/es.json");
const itTranslations = require("./locales/it.json");
const ptTranslations = require("./locales/pt.json");
// Alemán y francés: solo el camino hasta activar la cuenta (acceso, registro y
// alta guiada). Lo que falte cae en inglés por `fallbackLng`. Se añadieron el
// 21-9-2026: la landing ya trae visitantes de Alemania y Francia y el registro
// les salía en español, que era el idioma por defecto de la app.
const deTranslations = require("./locales/de.json");
const frTranslations = require("./locales/fr.json");

// Flatten nested translations for easier access, but move sidebar.ticket to top level
const flattenTranslations = (obj, prefix = "") => {
  let flattened = {};
  for (let key in obj) {
    if (typeof obj[key] === "object" && obj[key] !== null) {
      // Special handling for sidebar - process each property separately
      if (key === "sidebar") {
        const sidebarObj = obj[key];
        for (let sidebarKey in sidebarObj) {
          if (sidebarKey === "ticket") {
            // Move ticket translations to top level
            Object.assign(
              flattened,
              flattenTranslations(sidebarObj[sidebarKey], "ticket.")
            );
          } else if (
            typeof sidebarObj[sidebarKey] === "object" &&
            sidebarObj[sidebarKey] !== null
          ) {
            // Handle nested objects in sidebar (like ticket.status)
            Object.assign(
              flattened,
              flattenTranslations(
                sidebarObj[sidebarKey],
                "sidebar." + sidebarKey + "."
              )
            );
          } else {
            // Simple sidebar translations
            flattened["sidebar." + sidebarKey] = sidebarObj[sidebarKey];
          }
        }
      } else {
        Object.assign(
          flattened,
          flattenTranslations(obj[key], prefix + key + ".")
        );
      }
    } else {
      flattened[prefix + key] = obj[key];
    }
  }
  return flattened;
};

const resources = {
  en: { translation: flattenTranslations(enTranslations) },
  es: { translation: flattenTranslations(esTranslations) },
  it: { translation: flattenTranslations(itTranslations) },
  pt: { translation: flattenTranslations(ptTranslations) },
  de: { translation: flattenTranslations(deTranslations) },
  fr: { translation: flattenTranslations(frTranslations) },
};

// Idioma inicial: primero `?lang=` (lo manda la landing desde /de/, /fr/…),
// luego el del navegador y, si no encaja con ninguno, inglés.
const SUPPORTED = ["es", "en", "it", "pt", "de", "fr"];

const detectInitialLanguage = () => {
  try {
    const fromUrl = new URLSearchParams(window.location.search).get("lang");
    if (fromUrl && SUPPORTED.includes(fromUrl.slice(0, 2).toLowerCase())) {
      return fromUrl.slice(0, 2).toLowerCase();
    }
    const saved = localStorage.getItem("ws_lang");
    if (saved && SUPPORTED.includes(saved)) return saved;
    const nav = (navigator.language || "").slice(0, 2).toLowerCase();
    if (SUPPORTED.includes(nav)) return nav;
  } catch (e) {
    /* sin window/localStorage: inglés */
  }
  return "en";
};

// Initialize i18n synchronously
i18n.use(initReactI18next).init({
  resources,
  lng: detectInitialLanguage(),
  fallbackLng: "en",
  interpolation: { escapeValue: false },
  defaultNS: "translation",
  ns: ["translation"],
  react: {
    useSuspense: false, // Disable suspense to avoid loading issues
  },
});

// Se recuerda el idioma elegido para la siguiente visita.
i18n.on("languageChanged", (lng) => {
  try {
    localStorage.setItem("ws_lang", lng);
  } catch (e) {
    /* almacenamiento bloqueado: no pasa nada */
  }
  // El <html lang> sigue al idioma elegido: sin él la partición con guion automática (CSS) y los
  // lectores de pantalla usan «en» aunque la interfaz esté en alemán.
  try {
    document.documentElement.lang = lng;
  } catch (e) {
    /* sin DOM */
  }
});

export default i18n;
